import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const detectLanguage = () => {
    // First, check if language is in URL path
    const pathLang = location.pathname.split("/")[1];
    if (pathLang === "fr" || pathLang === "en") {
      return pathLang;
    }

    // Otherwise, detect from browser language
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split("-")[0].toLowerCase();
    return langCode === "fr" ? "fr" : "en";
  };

  const [language, setLanguage] = useState(detectLanguage);

  useEffect(() => {
    const pathLang = location.pathname.split("/")[1];
    if (pathLang === "fr" || pathLang === "en") {
      setLanguage(pathLang);
    }
  }, [location.pathname]);

  const changeLanguage = (newLang) => {
    setLanguage(newLang);
    const currentPath = location.pathname;
    // Remove language prefix if present, or keep the path
    let pathWithoutLang = currentPath.replace(/^\/(fr|en)/, "") || "/";
    // Ensure path starts with /
    if (!pathWithoutLang.startsWith("/")) {
      pathWithoutLang = "/" + pathWithoutLang;
    }
    const newPath = `/${newLang}${
      pathWithoutLang === "/" ? "" : pathWithoutLang
    }`;
    navigate(newPath);
  };

  const toggleLanguage = () => {
    const newLang = language === "fr" ? "en" : "fr";
    changeLanguage(newLang);
  };

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, changeLanguage, toggleLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
